module.exports = __webpack_public_path__ + "img/system_3_2.b988467e.png";